import {
  getPathName,
  changeCurrancyFormat,
} from "../../../../common/utils/utilsFunc";
import ClayTable from "@clayui/table";
import HeaderSearch from "../../../../common/components/HeaderSearch";
import HeaderTable from "../../../../common/components/HeaderTable";
import React, { useEffect, useState, useContext } from "react";
import arTitles from "../../../../common/services/mock/title.json";
import CgeContextProvider, { CgeContext, ACTIONS } from "../../context/CgeContextProvider";
import Loading from "../../../../common/components/Loading";
import { CGE } from "../../../../common/components/CGE";

import Pagination from "../../../../common/components/Pagination";

function TableCurrentStatus({
  title,
  description,
  qtdRowPage,
  textNoResults,
  textFetchError,
  setGlobalAlert,
}) {
  const [activePage, setActivePage] = useState(1);
  const [dataTable, setDataTable] = useState([]);
  const [inputSearch, setInputSearch] = useState("");
  const [inputSelected, setInputSelected] = useState("");
  const [loading, setLoading] = useState(false);
  const [rowPage, setRowPageList] = useState(10);
  const [state, dispatch] = useContext(CgeContext);
  const [currentArray, setCurrentArray] = useState([]);
  const [auxArray, setAuxArray] = useState([]);
  const [idList, setIdList] = useState([]);
  const [findOne, setFindOne] = React.useState(false);
  const [excelData, setExcelData] = React.useState(null);

  let error = null;

  const data = state.idList ? state.idList : [];
  let newArrTitle = arTitles[getPathName()]?.map((item) => item.label);

  function setRowPage(nPage) {
    setActivePage(1);
    setRowPageList(Number(nPage));
  }

  if (error && loading) {
    setLoading(false);
  }

  useEffect(() => {
    newArrTitle = arTitles[getPathName()]?.map((item) => item.label);
  }, [getPathName()]);

  useEffect(() => {
    if (inputSearch) {
    if (idList.find((idList) => idList.toString() === inputSearch)) {
        setInputSelected(inputSearch);
        document.getElementById("mySelectId").value = inputSearch;
    } else {
        setInputSelected("");
        document.getElementById("mySelectId").value = "";
    }
    }
  }, [inputSearch]);

  useEffect(() => {
    if (inputSelected) {
      setInputSearch("");
    }
  }, [inputSelected]);


  useEffect(() => {
    if (state.idList) {
      let data = state.idList;

      setIdList(data);
      if (data.length > 0) {
        setLoading(true);
        window.scrollTo({ top: 0, behavior: "smooth" });

        setInputSelected("");
        document.getElementById("mySelectId").value = "";
        dispatch({
          payload: { idClient: data, numPage: activePage, quantItems: rowPage },
          type: ACTIONS.SET_IDCLIENT,
        });
      } else {
        setIdList([]);
        setLoading(false);
        dispatch({
          payload: null,
          type: ACTIONS.SET_IDCLIENT,
        });
      }
    }
  }, [state.idList, rowPage, activePage]);

  useEffect(() => {
    const objCb = state.currentBalance;

    setLoading(false);
    if (objCb) {
      if (objCb.ConsultarListaEstadoServiciosResponse?.RETORNO?.RETURN === 0) {
        setDataTable(objCb.ConsultarListaEstadoServiciosResponse?.ITEM);
      } else if (state.currentBalance.status) {
        setGlobalAlert(textFetchError, "warning", true, "Advertencia");
      } else {
        setGlobalAlert(
          objCb.ConsultarListaEstadoServiciosResponse?.RETORNO?.TEXTO_RETURN,
          "warning",
          true,
          "Advertencia"
        );
      }
    }
  }, [state.currentBalance]);
  
  const propsTable = {
    title: title,
    description: description,
    setActivePage: setActivePage,
    qtdRowPage: qtdRowPage,
    setRowPage: setRowPage,
    rowPage: rowPage,
    activePage: activePage,
    auxArray: auxArray,
    arTitles: arTitles,
    excelBtn: true,
    excelFunc: true,
    showPagination: false,
    state: state,
    dispatch: dispatch,
    ACTIONS: ACTIONS,
    setLoading: setLoading,
    setGlobalAlert: setGlobalAlert,
    textFetchError: textFetchError,
    setExcelData: setExcelData,
    excelData: excelData
  };
  
  var panelFooter = (
    <>
      <div className="d-flex align-items-center justify-content-center flex-column-reverse pb-4">
        <Pagination
          items={auxArray?.length === 1 ? auxArray : idList}
          onChangePage={setActivePage}
          qtdRowPage={qtdRowPage}
          setRowPage={setRowPage}
          pageSize={rowPage}
          currentPg={activePage}
        />
      </div>
    </>
  );

  React.useEffect(() => {
    let filterArray = [];
    setAuxArray(dataTable);

    if (inputSelected) {
      filterArray = dataTable.filter(function (obj) {
        return obj.CTA_CTO.toString() === inputSelected;
      });
      if (filterArray?.length > 0) {
        setAuxArray(filterArray);
      } else {
        setLoading(true);
        dispatch({
          payload: { idClient: [inputSelected], numPage: 1, quantItems: 1 },
          type: ACTIONS.SET_IDCLIENT,
        });
      }
      setFindOne(true);
    } else if (!inputSelected && findOne) {
      setFindOne(false);
      setLoading(true);
      dispatch({
        payload: {
          idClient: state?.idList ? state.idList : [],
          numPage: activePage,
          quantItems: rowPage,
        },
        type: ACTIONS.SET_IDCLIENT,
      });
    }

    if (!inputSelected && !inputSearch) {
      setCurrentArray(dataTable?.sort((a, b) => a.CTA_CTO - b.CTA_CTO));
    } else if (dataTable?.length === 0) {
      setGlobalAlert(textFetchError, "warning", true, "Advertencia");
      setLoading(false);
    } else {
      setCurrentArray(filterArray?.sort((a, b) => a.CTA_CTO - b.CTA_CTO));
    }
  }, [inputSelected, dataTable, activePage]);

  React.useEffect(() => {
    if (state.errorFetch) {
      setLoading(false);
    }
  }, [state.errorFetch]);

  useEffect(() => {
    if(state.idClient != "undefined" &&  state.idClient != null){
      setLoading(true);
      dispatch({
        payload: true,
        type: ACTIONS.SET_LOAD_PAGE,
      });
    }
  }, []);

  return (
    <>
      <HeaderSearch
        data={data}
        setSearch={setInputSearch}
        setSelected={setInputSelected}
        idClient={inputSelected}
        inputSearch={inputSearch}
      />
      <div>
        <CGE.Panel footerContent={panelFooter}>
          <HeaderTable props={propsTable} />
          <ClayTable
            class="table table-striped table-autofit show-quick-actions-on-hover table-list table-nowrap tbody-valign-middle thead-valign-middle table-valign-middle"
            id="table-to-xls"
          >
            <ClayTable.Head>
              <ClayTable.Row>
                {newArrTitle?.map((title) => {
                  return (
                    <ClayTable.Cell headingCell className="clientCell font-weight-bold">
                      {title}
                    </ClayTable.Cell>
                  );
                })}
              </ClayTable.Row>
            </ClayTable.Head>
            <ClayTable.Body>
              {currentArray ? (
                currentArray?.map((obj) => {
                  return (
                    <ClayTable.Row className="tableRow">
                      {Object.keys(obj).map((index) => {
                        return (
                          <ClayTable.Cell
                            className=" txt-with-link clientCell-td table-cell-minw-150 table-cell-expand text-truncate"
                            title={obj[index].length > 23 ? obj[index] : ""}
                          >
                            {index === "ESTADO_PAGO" && obj[index] === "IMPAGO" ? (
                              <a
                                href={`detalle-de-cuenta-priv?ctacto=${obj["CTA_CTO"]}`}
                                className="text-decoration-none "
                              >
                                ¡PAGAR AQUÍ!
                              </a>
                            ) : index === "TOTAL_PAGAR" ? (
                              changeCurrancyFormat(Number(obj[index]), true)
                            ) : (
                              obj[index]
                            )}
                          </ClayTable.Cell>
                        );
                      })}
                    </ClayTable.Row>
                  );
                })
              ) : (
                <ClayTable.Row>
                  <ClayTable.Cell
                    colspan={newArrTitle?.length}
                    className="text-no-results  font-weight-bold"
                  >
                    {!loading && textNoResults}
                  </ClayTable.Cell>
                </ClayTable.Row>
              )}
            </ClayTable.Body>
          </ClayTable>
          {loading && <Loading />}
        </CGE.Panel>
      </div>
    </>
  );
}

const TableCurrentStatusWithProvider = ({
  title,
  description,
  qtdRowPage,
  textNoResults,
  textFetchError,
  setGlobalAlert,
}) => (
  <CgeContextProvider>
    <TableCurrentStatus
      title={title}
      description={description}
      qtdRowPage={qtdRowPage}
      textNoResults={textNoResults}
      textFetchError={textFetchError}
      setGlobalAlert={setGlobalAlert}
    />
  </CgeContextProvider>
);
export default TableCurrentStatusWithProvider;
